import React from 'react'
import FullcarsCard from './FullcarsCard'

const IndexFull = () => {
  return (
    <div style={{ fontFamily: 'Lato, sans-serif' }}>
      <FullcarsCard/>
    </div>
  )
}

export default IndexFull
